import { Accordion, AccordionDetails, AccordionSummary, Checkbox, ListItemIcon, ListItemSecondaryAction } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import React, { useEffect, useState } from "react";
import { useNotification } from "../../../../../Hooks/useNotification/useNotification";
import { v4 as uuid } from "uuid";
import { ReactComponent as EditIcon } from "../../../../../assets/images/edit-icon.svg";
import AppModel from "../../../../../Hooks/useModel/AppModel";
import { AppMaterialIcons } from "../../../../../AppComponents/AppMaterialIcons";
import AppButton from "../../../../../AppComponents/AppButton";
import { theme } from "../../../../../Customization/Theme";
import styled from "styled-components";
import { CatalogActions } from "../../../../../Store/Slices/catalog/catalog.actions";
import { debounce } from "lodash";
import CircularProgress from '@mui/material/CircularProgress';
import {
    Drawer, Typography, Toolbar, IconButton, AppBar, Card, CardContent,
    CardMedia, Grid, Box, Button, TextField, Badge, Divider, Chip, Snackbar, Alert, Tabs, Tab,
    List, ListItem, ListItemText, Collapse, Avatar
} from "@mui/material";
import AppPaginationComponent from "../../../../../AppComponents/Pagination/Pagination";
import { useAppDispatch } from "../../../../../Store";
interface Props {
    open: boolean;
    onClose: () => void;
    node?: any;
    type?: any;
    onConfirm?: () => void;
    onSelectProducts?: any;
    sendSelectedData?: any;
    selectedProductsList?: any;
    isThumbnail?:any
}
const MAX_PRODUCTS = 30;
const MAX_GROUPS = 10;
const MultiCatalogService = (props: Props) => {
    const { showAlert } = useNotification();
    const dispatch = useAppDispatch();
    const [searchQuery, setSearchQuery] = useState("");
    const [localValues, setLocalValues] = useState<any>({
        itemsPerPage: { label: "10  per page", value: 10 },
        currentPage: 0,
        search: "",
    });
    const [catalogProductList, setCatalogProductList] = useState<any>([]);
    const [pagination, setPagination] = useState<any>();
    const [seletedIdsList, setSeletedIdsList] = useState<any>();
    const [localLoading, setLocalLoading] = useState<any>();
    const [selectedProducts, setSelectedProducts] = useState<any[]>(props?.selectedProductsList);
    const [productGroups, setProductGroups] = useState<any[]>([{
        id: "565656",
        name: "Product",
        default: true,
        products: [],
        product_items: []
    }]);
    const [expandedGroup, setExpandedGroup] = useState<any>("565656");
    const [newGroupName, setNewGroupName] = useState("");
    const [renameGroupName, setRenameGroupName] = useState("Product");
    const [groupId, setGroupId] = useState("565656");
    const [isShowingModal, setIsShowingModal] = useState(false);
    const [thumbnailProduct, setThumbnailProduct] = useState(null);
    const [productCount, setProductCount] = useState(0);
    const [showError, setShowError] = useState(false);
    useEffect(() => {
        if (props?.node?.response?.[0]?.interactive?.action?.sections?.length > 0 && !props?.selectedProductsList) {
            setProductGroups(props?.node?.response?.[0]?.interactive?.action?.sections)
            if(props?.isThumbnail){
                setThumbnailProduct(props?.node?.response?.[0]?.interactive?.action?.thumbnail_product_retailer_id)
            }
        }
        if(props?.selectedProductsList){
            setProductGroups(props?.selectedProductsList)
        }
        fetchProducts("")
    }, [])
    useEffect(() => {
        fetchProducts("")
    }, [localValues || props?.type])
    useEffect(() => {
        const productCount = productGroups?.reduce((count: any, category: any) => count + category?.products?.length, 0);
        setProductCount(productCount)
    }, [productGroups])
    const handleCreateGroup = () => {
        if (productGroups.length >= MAX_GROUPS) {
            showAlert(`You can create up to ${MAX_GROUPS} groups only`, "error");
            return;
        }

        if (!newGroupName.trim()) {
            showAlert("Please enter a group name", "error");
            return;
        }

        const newGroup: any = {
            id: uuid(),
            name: newGroupName,
            products: [],
            product_items: []
        };

        setProductGroups([...productGroups, newGroup]);
        setNewGroupName("");
        setExpandedGroup(newGroup.id);
        setRenameGroupName(newGroup?.name);
        setGroupId(newGroup?.id)
    };
    const handleAccordionChange = (group: any) => {
        setExpandedGroup(expandedGroup === group?.id ? null : group?.id);
        setRenameGroupName(group?.name);
        setGroupId(group?.id);
    };
    const editName = (group: any) => {
        setIsShowingModal(true)
        setGroupId(group?.id);
    }
    const changeGroupName = () => {
        if (!renameGroupName.trim()) {
            showAlert("Please enter a group name", "error");
            return;
        }

        const updatedGroups = productGroups?.map(group => {
            if (group.id === groupId) {
                return { ...group, name: renameGroupName }
            }
            return group;
        });

        setProductGroups(updatedGroups);
        setIsShowingModal(false);
    }
    const handleRemoveGroup = (group: any) => {
        setProductGroups(productGroups?.filter(g => g.id !== group.id));
        if (expandedGroup === group.id) {
            setExpandedGroup(null);
        }
    }
    const fetchProducts = (seletedIds: any) => {
        setLocalLoading(true);
        const data = {
            limit: localValues?.itemsPerPage?.value,
            offset: localValues?.currentPage,
            search: localValues?.search,
            seletedIds: seletedIds
        };
        dispatch(CatalogActions.getCatalogProductList(data),
        ).then((save_result: any) => {
            setCatalogProductList(save_result?.payload?.data?.data);
            setPagination(save_result?.payload?.data?.pagination)
            setSelectedProducts(save_result?.payload?.data?.selectedProductList)
            setLocalLoading(false);

        })
            .catch((error: any) => { })
            .finally(() => {
                setLocalLoading(false);
            })
    }
    const debouncedSearch = React.useCallback(
        debounce((query: string) => {
            // Reset to first page when searching
            setLocalValues((prev: any) => ({
                ...prev,
                search: query,
                currentPage: 0
            }));
            // fetchProducts(selectedProducts?.[0]?.retailer_id);
        }, 500),
        [localValues]
    );
    function handlePageChange(event: any, value: any) {
        setLocalValues({
            ...localValues,
            currentPage: value - 1,
        });
    }
    const handleChangeRowsPerPage = (value: any) => {
        setLocalValues({
            ...localValues,
            itemsPerPage: value,
            currentPage: 0,
        });
    };

    // Handle search input change
    const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const query = e.target.value;
        setSearchQuery(query);
        debouncedSearch(query);
    };
    const handleSelectProduct = (product: any) => {

    }
    const handleDelete = () => {
        setSelectedProducts([])
    }
    const setGroupProduct = (product: any) => {
        console.log("product------------->", product, groupId);

        // set Group Product
        // console.log('setGroupProduct', product);
        const updatedGroups = productGroups?.map(group => {
            if (group.id === groupId) {
                return {
                    ...group,
                    products: [...group.products, product],
                    product_items: [
                        ...group.product_items,
                        { product_retailer_id: product?.retailer_id }
                    ]
                }
            }
            return group;
        });

        setProductGroups(updatedGroups);
    }
    const removeGroupProduct = (product: any) => {
        const updatedGroups = productGroups?.map(group => {
            if (group.id === groupId) {
                return {
                    ...group,
                    products: group.products.filter((p: any) => p.id !== product.id),
                    product_items: group.product_items.filter(
                        (item: any) => item.product_retailer_id !== product.retailer_id
                    )
                }
            }
            return group;
        });

        setProductGroups(updatedGroups);
    }

    const handleConfirmSelection = () => {

        console.log("productGroups", productGroups);
        // If collections are selected, get all their products
        if(!thumbnailProduct && props?.isThumbnail){
            setShowError(true)
            showAlert(`Please Select One Product for thumnail`, "error");
            return false;
        }
        setShowError(false)
        props?.sendSelectedData(productGroups,thumbnailProduct);
        if (props?.onSelectProducts) {
            props?.onSelectProducts(productGroups);
        }
        // // ✅ Call the passed debounce function
        if (props?.onConfirm) {
            props?.onConfirm();

        }
        props?.onClose();
        // const structuredData = {
        //     ungrouped: selectedProducts,
        //     groups: productGroups,
        //     collections: selectedCollections
        // };

        // sendSelectedData(structuredData);

        // if (onSelectProducts) {
        //     onSelectProducts(selectedProducts, productGroups, selectedCollections);
        // }
        // if (onConfirm) {
        //     onConfirm();
        // }
        // onClose();
    };
    console.log("productGroups", productGroups);

    return (
        <Drawer
            anchor="right"
            open={props?.open}
            onClose={props?.onClose}
            PaperProps={{
                sx: { width: { xs: '100%', sm: '80%', md: '90%' } }
            }}
            className="ignore-onClickOutside"
        >
            <AppBar position="sticky" color="primary" sx={{ padding: 1 }} className="ignore-onClickOutside">
                <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="h6" sx={{ color: "white" }}>
                        Select Products, Collections & Create Groups
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <IconButton onClick={props?.onClose} sx={{ color: "white" }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>
            <Box sx={{ display: 'flex', height: 'calc(100vh - 64px)' }} >
                <Box sx={{ width: '25%', borderRight: '1px solid #e0e0e0', backgroundColor: "#f5f5f5", overflowY: "auto" }}>
                    <Box sx={{ p: 2 }}>
                        <Typography variant="h6" gutterBottom>
                            Product Groups ({productGroups?.length}/{MAX_GROUPS})
                        </Typography>
                        <Box sx={{ display: 'flex', mb: 2 }}>
                            <TextField
                                size="small"
                                placeholder="New Group Name"
                                value={newGroupName}
                                onChange={(e) => setNewGroupName(e.target.value)}
                                fullWidth
                                sx={{ backgroundColor: "#fff" }}
                            />
                            <Button
                                variant="contained"
                                onClick={handleCreateGroup}
                                disabled={productGroups?.length >= MAX_GROUPS}
                                sx={{ ml: 1 }}
                            >
                                <AddIcon />
                            </Button>
                        </Box>
                        {showError ? <a style={{ color: "red"}}>Please Select One Product for thumnail</a> : null}


                        {productGroups?.map((group: any) => (
                            <Accordion
                                key={group.id}
                                expanded={expandedGroup === group.id}
                                onChange={() => handleAccordionChange(group)}
                                sx={{ mb: 1, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: expandedGroup === group.id ? "1px solid black" : "1px solid white" }}
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                        <Typography>{group.name} <EditIcon onClick={() => editName(group)} style={{ marginLeft: "12px", cursor: "pointer" }} /> </Typography>
                                        <Chip
                                            size="small"
                                            label={`${group.products.length}`}
                                            color="primary"
                                        />
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <List dense>
                                        {props?.isThumbnail ? <ListItemText primary={"Select thumbnail"} style={{fontSize:"10px"}}/>:null}
                                        {group?.products?.map((product: any) => (
                                            <ListItem key={product.id} disablePadding>
                                                {props?.isThumbnail ? <ListItemIcon>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={product.id === thumbnailProduct}
                                                        onChange={() => setThumbnailProduct(product.id)}
                                                        size="small"
                                                        name="Select thumbnail"
                                                    />
                                                </ListItemIcon>:null}
                                                <ListItemText primary={product.name} secondary={product.price} />
                                                <ListItemSecondaryAction>
                                                    <IconButton edge="end" onClick={() => removeGroupProduct(product)} size="small">
                                                        <DeleteOutlineIcon fontSize="small" />
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        ))}
                                    </List>
                                    {!group?.default ? <Button
                                        variant="outlined"
                                        color="error"
                                        size="small"
                                        startIcon={<DeleteOutlineIcon />}
                                        onClick={() => handleRemoveGroup(group)}
                                        fullWidth
                                        sx={{ mt: 1 }}
                                    >
                                        Remove Group
                                    </Button> : null}
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                </Box>
                <Box sx={{ width: '75%', overflowY: "auto" }}>
                    <Typography variant="h6" gutterBottom style={{ margin: "6px 16px" }}>
                        Selected Product ({productCount}/{MAX_PRODUCTS})
                    </Typography>
                    <Box sx={{ padding: 2, backgroundColor: "#f5f5f5", position: 'relative' }} className="ignore-onClickOutside">
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Search Products..."
                            value={searchQuery}
                            onChange={handleSearchInputChange}
                            sx={{ backgroundColor: "#fff", borderRadius: '5px' }}
                        />

                    </Box>
                    {renameGroupName ? <Box style={{ marginLeft: "13px", padding: "12px" }} className="ignore-onClickOutside">
                        <Chip
                            label={renameGroupName}
                            variant="outlined"
                        />
                    </Box> : null}
                    <Box
                        sx={{
                            overflowY: "auto",
                            // height: selectedProducts.length > 0 ? "50vh" : "calc(100vh - 140px)",
                            height: "calc(100vh - 140px)",
                            padding: 2,
                            backgroundColor: "#f9f9f9"
                        }}
                    >
                        {localLoading ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: 'center',
                                    position: "absolute",
                                    top: "50%",
                                    right: "50%"
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        ) : (
                            <Grid container spacing={2} className="ignore-onClickOutside">
                                {catalogProductList?.length > 0 ? (
                                    catalogProductList?.map((product: any) => {
                                        // ✅ Check if product is pre-selected
                                        const productIds: any = productGroups?.filter(group => group.id === groupId);
                                        const ids = productIds?.[0]?.products?.map((product: any) => product.retailer_id);
                                        const isDefaultSelected = ids?.includes(product.retailer_id);
                                        const selected = isDefaultSelected;
                                        console.log("ids", productIds, ids, isDefaultSelected);

                                        return (
                                            <Grid item xs={12} key={product.id} className="ignore-onClickOutside">
                                                <Card
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        padding: 2,
                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                        transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                                                        '&:hover': {
                                                            transform: 'translateY(-4px)',
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                        },
                                                        border: selected ? '1px solid #4caf50' : 'none',
                                                        backgroundColor: selected ? 'rgba(76, 175, 80, 0.05)' : 'white'
                                                    }}
                                                >
                                                    <CardMedia
                                                        component="img"
                                                        sx={{ width: 80, height: 80, borderRadius: "8px", marginRight: 2, objectFit: "cover" }}
                                                        image={product.image_url}
                                                        alt={product.name}
                                                    />
                                                    <CardContent sx={{ flexGrow: 1, padding: "8px 16px 8px 0" }}>
                                                        <Typography variant="subtitle1">{product.name}</Typography>
                                                        <Typography
                                                            variant="body1"
                                                            color="primary"
                                                            fontWeight="bold"
                                                            sx={{ marginTop: 1, display: "flex", alignItems: "center" }}
                                                        >
                                                            {product.price}
                                                        </Typography>
                                                    </CardContent>
                                                    <Button
                                                        variant={selected ? "outlined" : "contained"}
                                                        color={selected ? "success" : "primary"}
                                                        size="small"
                                                        startIcon={selected ? <CheckCircleIcon /> : <AddIcon />}
                                                        onClick={() =>
                                                            selected ? removeGroupProduct(product) :
                                                                setGroupProduct(product)
                                                        }
                                                        // disabled={!selected && type === "multiple_product" && selectedProducts.length >= MAX_PRODUCTS}
                                                        sx={{
                                                            minWidth: "120px",
                                                            borderRadius: "20px",
                                                            bgcolor: selected ? "rgba(46, 125, 50, 0.1)" : undefined
                                                        }}
                                                    >
                                                        {selected ? "Selected" : "Select"}
                                                    </Button>
                                                </Card>
                                            </Grid>
                                        );
                                    })
                                ) : (
                                    <Typography sx={{ padding: 2, textAlign: "center", color: "gray", width: "100%" }}>
                                        No products found.
                                    </Typography>
                                )}

                                <Box style={{ width: "100%" }}>
                                    <AppPaginationComponent
                                        totalCount={pagination?.totalRecords}
                                        handlePageChange={handlePageChange}
                                        currentPage={localValues?.currentPage}
                                        totalPages={pagination?.totalPages}
                                        rowsPerPage={localValues?.itemsPerPage}
                                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                </Box>
                            </Grid>
                        )}
                    </Box>;
                </Box>
            </Box>
            <Box sx={{ backgroundColor: "#fff", padding: 2, borderTop: "1px solid #e0e0e0", position: "sticky", bottom: 0 }}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleConfirmSelection}
                    disabled={productCount > 30}
                >
                    Confirm Selection {productCount} Product
                </Button>
            </Box>

            <AppModel
                isShowing={isShowingModal}
                onClose={() => {
                    setIsShowingModal(false);
                }}
                divStyle={{
                    padding: 0,
                }}
                PaperProps={{
                    style: {
                        boxShadow: "none",
                        width: "500px",
                        height: "250px",
                    },
                }}
            >
                <ModalContainer>
                    <div className="header">
                        <h4>
                            Change Group Name
                        </h4>
                        <div className="header-right">
                            <span
                                onClick={() => {

                                }}
                            >
                                <AppMaterialIcons iconName="close" />
                            </span>
                        </div>
                    </div>
                    <div className="body">
                        <h4 style={{ marginBottom: "11px" }}>
                            Group Name
                        </h4>
                        <TextField
                            size="small"
                            placeholder="New Group Name"
                            value={renameGroupName}
                            onChange={(e) => setRenameGroupName(e.target.value)}
                            fullWidth
                            sx={{ border: "1px solid lightgray" }}
                        />
                    </div>
                    <div className="footer">
                        <AppButton
                            variant="grey"
                            onClick={() => {
                                setIsShowingModal(false);
                            }}
                        >
                            Cancel
                        </AppButton>
                        <AppButton
                            onClick={() => {
                                changeGroupName();
                            }}
                        >
                            Save
                        </AppButton>
                    </div>
                </ModalContainer>
            </AppModel>
        </Drawer>

    )

}
const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    border-bottom: 1px solid rgba(203, 205, 211, 0.3);
    padding:0 0.8rem;
    .header-left {
      display: flex;
      gap: 0.875rem;
      }
      .text h4 {
        font-size: 1.1rem;
        font-weight: 500;
      }
      .text p {
        color: ${theme.palette.default.darkGrey};
      }
    }
    .header-right {
      .MuiSvgIcon-root {
        color: ${theme.palette.default.darkGrey};
      }
      cursor: pointer;
    }
  }
  .content{
    margin:10px 0;
    padding: 10px 15px; 
}
  .body {
    padding: 0.8rem;
    height: calc(100% - 110px);
    p {
    margin-bottom: 20px;
    font-size: 16px;
    }
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    padding: 0.875rem;
    border-top: 1px solid ${theme.palette.default.border};
    .change-template-name {
      display: flex;
      justify-content: space-between;
      align-items: start;
      p.change-name {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
`;
export default MultiCatalogService;